<template>
  <div class="clearfix">
    <a-upload
            action=""
            listType="picture-card"
            :file-list="fileList"
            accept="video/*"
            :remove="onRemove"
            @preview="handlePreview"
            @change="onChange"
            :multiple="multiple"
            :before-upload="beforeUpload"
            :customRequest="uploadFile"
    >
      <div v-if="fileList.length < numberLimit">
        <a-icon type="plus" />
        <div class="ant-upload-text">选择视频</div>
      </div>
    </a-upload>
    <a-modal
        :maskClosable="false" :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <video alt="example" style="width: 100%" :src="previewImage" controls ref="video" />
<!--      <video width="100%" controls ref="videos">-->
<!--        <source :src="url">-->
<!--      </video>-->
    </a-modal>
  </div>
</template>
<script>
  import OSS from 'ali-oss';
  export default {
    name: 'VideoUploader',
    data () {
      return {
        previewVisible: false,
        previewImage: '',
        ossAccessTokenURL: 'https://api.ccachina.net/core/attachment/aliOssSts',
        ossFileURL: 'https://ccago.oss-cn-hangzhou.aliyuncs.com',
      }
    },
    props: {
      fileList: {
        type: Array,
        required: true,
      },
      numberLimit:{
        type: Number|String,
        default:100
      },
      multiple:{
        type: Boolean,
        default:false
      }
    },
    methods: {
      onRemove(file){
        const that = this;
        this.fileList.forEach(function (element, index) {
          if (element.uid == file.uid) {
            that.fileList.splice(index, 1);
          }
        }, this);
      },
      beforeUpload(file){
        console.log('file');
        console.log(file);
      },
      uploadFile(evt){
        console.log('evt');
        console.log(evt);

        var that = this;
        console.log(that.ossFileURL);
        evt.onProgress({percent: 0});
        OSS.urllib.request(this.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
          let result;
          if (err) {
            that.$message.error('上传异常:' + err);
            console && console.error(err);
            evt.onError(100);
            return;
          }
          try {
            result = JSON.parse(response);
          } catch (e) {
            return alert('parse sts response info error: ' + e.message);
          }
          var client = new OSS({
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            endpoint: result.data.endpoint,
            bucket: result.data.bucket,
            secure: true
          });
          var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];
          console.log(that.ossFileURL);
          var myDate = new Date();
          var file_save_name = 'uploader/000/user-xxx/' + evt.file.uid + '.' + suffix;
          console.log(file_save_name);
          client.multipartUpload(file_save_name, evt.file).then(function (result) {
            evt.onSuccess();
            console.log(that.ossFileURL);
            var file = {
              uid: evt.file.uid,
              url: that.ossFileURL + '/' + file_save_name,
              name: evt.file.name,
              save_name: file_save_name
            }
            evt.onProgress({
              percent: 100,
            });
            that.fileList.push(file);

            console.log('fileList', that.fileList)
            that.$message.success(evt.file.name + '上传成功');
          }).catch(function (err) {
            evt.onError();
            that.$message.error(evt.file.name + '上传失败');
          });
        });
      },
      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        let that = this;
        this.previewImage = file.url || file.thumbUrl
        // that.$refs.videos.src = file.url
        this.previewVisible = true
      },
      onChange(){

      }
    },
  }
</script>
<style>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
